<ng-container>
  <input
    type="text"
    nz-input
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="writeValue($event)"
    [disabled]="disabled"
    [name]="controlName"
    (blur)="onFieldBlur($event)"
    [maxLength]="field.MaxLength ?? 255"
  />
  <a
    nz-button
    [nzLoading]="aiLoading"
    style="margin-top: 10px"
    *ngIf="
      field.AdditionalData != null &&
      field.AdditionalData.useAiGeneration != null &&
      field.AdditionalData.useAiGeneration === true &&
      field.AdditionalData.aigenerationQuestion != null
    "
    class="ai-icon"
    (click)="aiLoading === false ? getAIText() : null"
  >
    <span>{{'Generate Text with AI'  | translate}}</span>
  </a>
</ng-container>
